import formatDurationValue from './duration-usage-formatter';
import formatMonetaryValue from './monetary-usage-formatter';
import formatVolumeValue from './volume-usage-formatter';
import formatSmsValue from './sms-usage-formatter';
import I18n from '../i18n';

export const formatValue = (value, unitType, withoutLabel, withoutDecimals, unitWhenZero) => {
  if (value === 'UNL') {
    return I18n.t('VALUE_UNL');
  }

  if (isNaN(value)) {
    return value;
  }

  const valueFormatters = {
    DURATION: formatDurationValue,
    MONETARY: formatMonetaryValue,
    VOLUME: formatVolumeValue,
    SMS: formatSmsValue,
  };

  if (unitType in valueFormatters) {
    return valueFormatters[unitType](value, withoutLabel, withoutDecimals, unitWhenZero);
  }

  return value;
};

export { getPlanFirstItem } from './plan-presentation-formatter';
export { getPlanSecondItem } from './plan-presentation-formatter';
export { getPlanRoamingItem } from './plan-presentation-formatter';
